import cn from 'classnames';
import { TagLink } from '#components/patterns/entity-links/tag-link/TagLink.tsx';
import type { TagName } from '#dn-types/host.ts';
import styles from './TagReorderRow.module.css';

type Props = { name: TagName; description: string };

export function TagReorderRow({ name, description }: Props) {
  return (
    <div className={styles.TagReorderRow}>
      <div className={styles.TagReorderRow_nameContainer}>
        <TagLink className={cn('a truncate', styles.TagReorderRow_name)} tagName={name} title={name} />
      </div>
      <div className={cn('truncate', styles.TagReorderRow_description)}>{description}</div>
    </div>
  );
}
